import PartnerDetailsRequest from "../../../api/raily/partner/details/partner-details.request";
import PartnerDetailsParams from "./partner-details-params";

const create = (params: PartnerDetailsParams): PartnerDetailsRequest => {
  return {
    fleetPartnerId: params.fleetPartnerUuid,
  };
};

const partnerDetailsParamsFactory = {
  create,
};

export default partnerDetailsParamsFactory;
